export default __webpack_public_path__ + "static/media/next-message.9deab7b6.svg";